module.exports = __webpack_public_path__ + "static/barbie-cdb44f860c373bd24bdd6948a2aa37cd.jpg";